import React, { useEffect } from 'react';
import Trigger from '@magento/venia-ui/lib/components/Trigger';
import defaultClasses from './topTabNavigation.module.css';
import { useMergeCssClasses } from '../../Utils/utils';
import { useLocation } from 'react-router-dom';

var TopTabNavigationLink = function TopTabNavigationLink(_ref) {
  var item = _ref.item,
      active = _ref.active,
      handleActiveTab = _ref.handleActiveTab,
      propClasses = _ref.classes,
      _ref$isResourcePage = _ref.isResourcePage,
      isResourcePage = _ref$isResourcePage === void 0 ? false : _ref$isResourcePage;
  var location = useLocation();
  var classes = useMergeCssClasses(defaultClasses, propClasses);
  var activeClass = active ? classes.activeUnderline : classes.inactiveUnderline;
  useEffect(function () {
    if (item) {
      var _pathnameSplitArray, _pathnameSplitArray2;

      var linksWrapper = document.getElementById('links-wrapper');
      var pathnameSplitArray;
      var myElement;
      pathnameSplitArray = location.pathname.split('/');
      myElement = document.getElementById((_pathnameSplitArray = pathnameSplitArray) === null || _pathnameSplitArray === void 0 ? void 0 : _pathnameSplitArray[((_pathnameSplitArray2 = pathnameSplitArray) === null || _pathnameSplitArray2 === void 0 ? void 0 : _pathnameSplitArray2.length) - 1]);

      if (isResourcePage) {
        pathnameSplitArray = new URLSearchParams(location.search).get('tab');
        myElement = document.getElementById(pathnameSplitArray);
      }

      if (location.pathname.includes('resources') && myElement) {
        var _myElement;

        var leftPos = (_myElement = myElement) === null || _myElement === void 0 ? void 0 : _myElement.offsetLeft;
        linksWrapper.scroll(leftPos, 0);
      }

      if (location.pathname.includes('about/partnerships') && myElement) {
        var _myElement2;

        var _leftPos = (_myElement2 = myElement) === null || _myElement2 === void 0 ? void 0 : _myElement2.offsetLeft;

        linksWrapper.scroll(_leftPos, 0);
      }
    }
  }, [item]);
  return React.createElement("li", {
    className: classes.linkListItem,
    id: item.id
  }, React.createElement(Trigger, {
    classes: {
      root: activeClass
    },
    action: function action() {
      return handleActiveTab(item.id);
    },
    "aria-label": "Active Resource tab is ".concat(item.title)
  }, item.title));
};

export default TopTabNavigationLink;